import React, { Component } from "react";
import PropTypes from "prop-types";
import { apiUrl, s3initialurl, s3PresignedUrlGen } from "../config/apiUrl";
import Loading from "../../lib/steps_components/common/Loading";
import { getSessionId } from "../utils/sessionmanagement";

class UploadFileComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Initially, no file is selected
      selectedFile: null,
      loading: true,
      uploadClicked: false,
    };
  }

  // On file select (from the pop up)
  onFileChange = (event) => {
    // Update the state
    this.setState({ selectedFile: event.target.files[0] });
  };

  // On file upload (click the upload button)
  onFileUpload = () => {
    if (this.state.selectedFile && !this.state.uploadClicked) {
      this.setState({ uploadClicked: true });
      const name = this.props.name;
      const chatFormIdentifier = this.props.chatFormIdentifier;
      const type = this.props.type;
      let identifier = this.props.identifier;
      let identifierType = this.props.identifierType;
      let sessionId = getSessionId();

      let url = s3PresignedUrlGen;
      let body = {
        origin: "chat_bot",
        filename: this.state.selectedFile.name,
      };

      fetch(url, {
        method: "post",
        body: JSON.stringify(body),
      })
        .then((res) => res.json())
        .then((dataReceived) => {
          let urlFilePost = dataReceived.signedUrl;
          let filepath = dataReceived.key;
          fetch(urlFilePost, {
            method: "put",
            body: this.state.selectedFile,
          }).then((res) => {
            if (res.status === 200) {
              let urlFileInfo = `${apiUrl}candidate-response/`;
              let body = {
                chat_identifier: chatFormIdentifier,
                session_id: sessionId,
                identifier: identifier,
                identifier_type: identifierType,
                type: type,
                response: {
                  [name]: s3initialurl + filepath,
                },
              };
              fetch(urlFileInfo, {
                method: "post",
                body: JSON.stringify(body),
                headers: {
                  "Content-Type": "application/json",
                },
              })
                .then((res) => res.json())
                .then((dataReceived) => {
                  this.setState({ loading: false });
                  this.props.triggerNextStep();
                });
            }
          });
        });
    } else if (!this.state.selectedFile) {
      alert("please select a file");
    } else {
    }
  };

  fileData = () => {
    if (this.state.selectedFile) {
      return (
        <div style={{ fontWeight: "700" }}>
          <h4>File Details:</h4>
          <p>File Name: {this.state.selectedFile.name}</p>
        </div>
      );
    }
  };

  render() {
    return (
      <div>
        <div> Please upload Image</div>
        {this.fileData()}
        <div>
          <input
            type='file'
            style={{
              marginTop: "10px",
              background: "white",
              color: "black",
              maxWidth: "170px",
              borderRadius: "5px",
              padding: "7px 5px",
            }}
            onChange={this.onFileChange}
          />
          <div>
            <br />
          </div>
          <div
            style={{
              background: this.state.selectedFile ? "#fff" : "#b2b2b2",
              borderRadius: "5px",
              padding: "5px 7px",
              color: this.state.selectedFile ? "#111" : "#f6f6f6",
              boxShadow:
                "0px 2px 11px rgb(0 0 0 / 30%), 0px 2px 6px rgb(0 0 0 / 15%",
              width: "30%",
              margin: "5px auto",
            }}
            onClick={this.onFileUpload}
          >
            Upload
          </div>
        </div>
        {this.state.loading && this.state.uploadClicked ? <Loading /> : null}
      </div>
    );
  }
}

UploadFileComponent.propTypes = {
  steps: PropTypes.object,
};

UploadFileComponent.defaultProps = {
  steps: undefined,
};

export default UploadFileComponent;
